import { Model } from "vue-mc";
import { WP_LINKS } from "@/plugins/Constants";

class BlogMedia extends Model {
  options() {
    return {
      editable: true,
      methods: {
        image: "GET",
      },
    };
  }

  defaults() {
    return {
      source_url: WP_LINKS.blogDefault,
      id: 0,
    };
  }

  routes() {
    return {
      image: "source_url",
    };
  }

  image(id) {
    let method = this.getOption("methods.image");
    let url = WP_LINKS.media + id;
    let data = { id: this.id };

    return this.createRequest({ method, url, data }).send();
  }
}

export default BlogMedia;
